import { createSlice } from '@reduxjs/toolkit';
import { openCreateCustomerAgentActionWizardAction, closeCreateCustomerAgentActionWizardAction } from 'forms-ai-lib/internal/actions/customerAgent';
const initialState = {
  formId: null,
  stepIndex: 0
};
export const customerAgentActionCreatorSlice = createSlice({
  name: 'customerAgentActionCreator',
  initialState,
  reducers: {
    updateStepIndex: (state, action) => {
      state.stepIndex = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(openCreateCustomerAgentActionWizardAction, (state, action) => {
      state.formId = action.payload;
    });
    builder.addCase(closeCreateCustomerAgentActionWizardAction, state => {
      state.formId = null;
      state.stepIndex = 0;
    });
  }
});
export const {
  updateStepIndex
} = customerAgentActionCreatorSlice.actions;